import { useState } from 'react';

const FAQ_ITEMS = [
  {
    id: 1,
    q: '91视频网站上的国产视频都是免费观看的吗？',
    a: '是的，91视频网站上的所有91国产视频、国产电影、电视剧和综艺节目均免费提供在线观看服务。我们坚持免费开放的运营理念，让每一位用户都能无障碍地享受优质的国产影视内容。',
  },
  {
    id: 2,
    q: '91国产视频的画质怎么样？能看高清吗？',
    a: '91视频网站全面支持1080P高清画质播放。我们采用先进的视频编码和CDN分发技术，确保在流畅播放的同时呈现清晰细腻的画面。您可以根据网络状况自行选择合适的画质档位。',
  },
  {
    id: 3,
    q: '如何查找特定的91年国产影片？',
    a: '您可以通过首页"片库索引"按分类浏览，或在站内使用搜索功能输入影片名称或关键词进行查找。我们为91年国产影片设立了专门的分类入口，方便您快速定位目标内容。',
  },
  {
    id: 4,
    q: '91视频网站支持哪些设备观看？',
    a: '91视频网站全面支持PC电脑、安卓手机、苹果手机和平板电脑等多种设备。您可以通过浏览器直接访问，也可以使用我们提供的移动客户端获得更优化的观影体验。',
  },
  {
    id: 5,
    q: '网站内容多久更新一次？',
    a: '我们保持每日更新频率。国产电视剧按播出进度同步更新，综艺节目当晚上线，经典91国产影片持续扩充片库。您可以关注"最新动态"板块了解每日更新详情。',
  },
  {
    id: 6,
    q: '观看91国产视频需要注册账号吗？',
    a: '不需要注册即可免费观看91视频网站上的所有内容。我们提供即点即看的便捷体验，无需账号登录，无强制注册流程。如果您希望收藏影片或订阅更新提醒，可以选择自愿注册。',
  },
];

export default function FaqSection() {
  const [openId, setOpenId] = useState<number>(1);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-500">关于91视频网站的常见疑问解答</p>
        </div>
        <div className="space-y-3">
          {FAQ_ITEMS.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl overflow-hidden cursor-pointer"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left"
                onClick={() => setOpenId(openId === item.id ? 0 : item.id)}
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">{item.q}</h3>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 flex-shrink-0 transition-transform duration-300 ${
                    openId === item.id ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === item.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}